/*************************************************/
/* SEARCHBAR                                      /
/*************************************************/

export function searchbar($body) {
    let $searchContainer,
        $searchForm,
        $searchInput,
        $searchToggler,
        showSearchClass;

    const init = function () {
        $searchContainer = $(".search-bar"),
            $searchForm = $searchContainer.find("form"),
            $searchInput = $searchContainer.find(".search-form__input"),
            $searchToggler = $(".search-bar__toggle"),
            showSearchClass = "search-active";

        $searchToggler.click(function () {
            handleSearchBarVisibility();
            $searchInput.focus();
        });

        $($searchContainer).click(function (e) {
            e.stopPropagation();
        });

        $($searchToggler).click(function (e) {
            e.stopPropagation();
        });

        $body.click(function () {
            closeSearch();
        });

        function handleSearchBarVisibility() {
            if (!$body.hasClass(showSearchClass)) {
                openSearch();
            } else {
                closeSearch();
            }
        }

        function openSearch() {
            $body.addClass(showSearchClass);
        }

        function closeSearch() {
            $body.removeClass(showSearchClass);
        }
    };

    init();
}